const formFields = [
  {
    key: 'otherConsideration',
    label: 'Other Consideration',
    type: 'text',
    isRequired: true,
  },
  {
    key: 'description',
    label: 'Description',
    type: 'textArea',
  },
  {
    key: 'impactOnMitigationTimeLine',
    label: 'Impact on Mitigation Timeline',
    type: 'time',
    decoratorWord: 'months',
  },
  { type: 'autocomplete' },
];

export { formFields };
